var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"title":_vm.$t('account.title')}}),_c('div',{staticClass:"full-page-box",staticStyle:{"min-height":"calc(100vh)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }